export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10057.0171c15c.jpg";